import React, { Component } from 'react';
import { browserHistory, Link } from 'react-router';
import Header from '../../components/Header';
import Bugsnag from '../../helpers/bugsnag';
import withNotify from '../../common/withNotify';
import withLoader from '../../common/withLoader';
import withGoBack from '../../common/withGoBack';
import { onGoBack } from '../../common/globals';

class SessionList extends Component {
    _onClickDone = () => {
      try {
        this._onGoBack();
        browserHistory.push('/inventory/consignment/scan-session');
      } catch (e) {
        Bugsnag.notify(e);
      }
    }

    _goBack = () => {
      try {
        const { goBack } = this.props;
        onGoBack(goBack);
      } catch (e) {
        Bugsnag.notify(e);
      }
    }

    render() {
      return (
        <section className="list-section resizer-class">
          <Header
            actionButton={{ title: 'Done', onClick: this._onClickDone }}
            title="Select Session"
            goBack={this._goBack}
          />
          <section className="case-details-section">
            <div className="container">
              <div className="row gx-2">
                <div className="col-6 offset-6">
                  <div className="case-data mb-4">
                    <Link className="btn btn-theme-alt d-block">Select All</Link>
                  </div>
                </div>
                <div className="col-12 col-md-12">
                  <p>Session Name <br />Session id</p>
                </div>
                <hr />
                <div className="col-12 col-md-12">
                  <p>Session Name <br />Session id</p>
                </div>
                <hr />
                <div className="col-12 col-md-12">
                  <p>Session Name <br />Session id</p>
                </div>
                <hr />
                <div className="col-12 col-md-12">
                  <p>Session Name <br />Session id</p>
                </div>
                <hr />
                <div className="col-12 col-md-12">
                  <p>Session Name <br />Session id</p>
                </div>
              </div>
            </div>
          </section>
        </section>
      );
    }
}

export default withLoader(withNotify(withGoBack(SessionList)));
